import { render, staticRenderFns } from "./PresentacionPage.vue?vue&type=template&id=691131bb"
import script from "./PresentacionPage.js?vue&type=script&lang=js&external"
export * from "./PresentacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports